// Enum các loại phụ lục tờ khai thuế
export default {
  TaSaleListOut: 0, // Bảng kê hàng hóa bán ra
  TaSaleListIn: 1, // Bảng kê hàng hóa mua vào
  TaPL01KHBS: 2, // Phụ lục tờ khai bổ sung
  TaPL011KHBS: 3, // Phụ lục giải trình khai bổ sung
  Ta432022QH15: 4, // Phụ lục theo Nghị quyết 43/2022/QH15
};
